import './App.scss';
import {
  Suspense,
  useState,
  useRef,
  forwardRef,
  createRef,
  useEffect,
} from 'react';
import { Route, Switch, Link, useLocation } from 'react-router-dom';
import { Canvas, useFrame, useThree } from '@react-three/fiber';
import { a, useSpring } from '@react-spring/three';
import { GridHelper } from 'three';
import {
  OrbitControls,
  SpotLight,
  Shadow,
  Stars,
  softShadows,
} from '@react-three/drei';
import * as THREE from 'three';
import { AnimatePresence } from 'framer-motion';

import Lights from './CanvasConfig/Lights/Lights';
import { MyStars } from './CanvasConfig/MyStars/MyStars';
import { MyStars2 } from './CanvasConfig/MyStars2/MyStars2';
import PostProcessing from './CanvasConfig/PostProcessing/PostProcessing';
import Rig from './CanvasConfig/Rig/Rig';
import Planet from './Planet/Planet';

import Home from './pages/Home/Home';
import About from './pages/About/About';
import Skills from './pages/Skills/Skills';
import Projects from './pages/Projects/Projects';
import ParticularProject from './pages/ParticularProject/ParticlarProject';
import Journey from './pages/Journey/Journey';

import PcNavbar from './Components/PcNavbar/PcNavbar';
import ContactForm from './Components/ContactForm/ContactForm';

function App() {
  const [explode, setExplode] = useState(false);
  const [routeisHome, setrouteIsHome] = useState(true);
  const [darkenNavbar, setDarkenNavbar] = useState(false);

  const location = useLocation();
  softShadows();

  useEffect(() => {
    if (location) {
      if (location.pathname !== '/') {
        setrouteIsHome(false);
        let audioElement = document.getElementById('bgMusic');
        if (audioElement) audioElement.play();
      } else setrouteIsHome(true);
    }
  });
  useEffect(() => {
    resizeHeightOnMobile();
  }, []);

  const resizeHeightOnMobile = () => {
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
  };

  // useEffect(() => {
  //   let element = document.getElementById('pulse');
  //   console.log(element);
  //   element.play();
  // }, [explode]);

  return (
    <div className="App">
      <Canvas
        shadows={true}
        colorManagement
        camera={{ position: [0, 0, 100] }}
        // gl={{
        //   powerPreference: 'high-performance',
        //   alpha: false,
        //   antialias: true,
        //   stencil: false,
        //   depth: false,
        // }}
        className="myCanvas"
      >
        <color attach="background" args={['#022A2E']} />

        <fog color="#060600" attach="fog" near={50} far={200} />
        {/* <axesHelper />
        <gridHelper /> */}
        <OrbitControls />
        <Lights />
        <Rig explode={explode} />
        <Suspense fallback={null}>
          <Planet explode={explode} />
        </Suspense>
        <MyStars2 />
        {/* <MyStars
          radius={100}
          depth={50}
          count={5000}
          factor={4}
          saturation={0}
          fade
        /> */}
        <Stars
          radius={100}
          depth={50}
          count={5000}
          factor={4}
          saturation={0}
          fade
        />
        <Shadow
          color="black"
          colorStop={0}
          opacity={0.5}
          fog={true} // Reacts to fog (default=false)
        />
        <PostProcessing />
      </Canvas>

      <audio
        id="bgMusic"
        src="https://res.cloudinary.com/drolmjcot/video/upload/v1626033477/audio/Zack_Hemsey_-_The_Way_Instrumental_lwlxdo.mp3"
        preload="metadata"
        type="audio/wav"
        autoPlay
        loop
      ></audio>

      {/*===========Navbars=============*/}
      <PcNavbar
        setExplode={setExplode}
        topPosition={routeisHome}
        darkenNavbar={darkenNavbar}
      />
      {/*=============================== */}

      {/*===========Contact Form =========*/}
      <ContactForm />
      {/*=================================*/}
      {/*===========Routes==============*/}
      <AnimatePresence initial="false">
        <Switch location={location} key={location.pathname}>
          <Route
            exact
            path="/"
            render={(routeProps) => (
              <Home
                {...routeProps}
                setExplode={setExplode}
                setDarkenNavbar={setDarkenNavbar}
              />
            )}
          />
          <Route
            exact
            path="/about"
            render={(routeProps) => (
              <About
                {...routeProps}
                setExplode={setExplode}
                setDarkenNavbar={setDarkenNavbar}
              />
            )}
          />
          <Route
            exact
            path="/skills"
            render={(routeProps) => (
              <Skills
                {...routeProps}
                setExplode={setExplode}
                setDarkenNavbar={setDarkenNavbar}
              />
            )}
          />
          <Route
            exact
            path="/projects"
            render={(routeProps) => (
              <Projects
                {...routeProps}
                setExplode={setExplode}
                setDarkenNavbar={setDarkenNavbar}
              />
            )}
          />
          <Route
            exact
            path="/projects/:id"
            render={(routeProps) => (
              <ParticularProject
                {...routeProps}
                setExplode={setExplode}
                setDarkenNavbar={setDarkenNavbar}
              />
            )}
          />
          <Route
            exact
            path="/journey"
            render={(routeProps) => (
              <Journey
                {...routeProps}
                setExplode={setExplode}
                setDarkenNavbar={setDarkenNavbar}
              />
            )}
          />
        </Switch>
      </AnimatePresence>

      {/*===============================*/}
    </div>
  );
}

export default App;
